/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_FromInputs */

const de__field_from = /** @type {(inputs: _Field_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`von`)
};

/**

* @param {_Field_FromInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_from = /** @type {((inputs?: _Field_FromInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_FromInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_from(inputs)
});